import React from 'react';
import { getRelocationCopy } from '../../constants/site';
import { useRelocationForm } from '../../hooks/useRelocationForm';
import { RelocationModalHeader } from './relocation/RelocationModalHeader';
import { RelocationFeatureStrip, RelocationSuccess } from './relocation/RelocationFeatureStrip';
import { RelocationGuideForm } from './relocation/RelocationGuideForm';

export const RelocationGuideModal = ({ open, onClose, openPrivacyPolicy, initialArea }) => {
  const { form, update, submitted, submitting, handleSubmit } = useRelocationForm({ open, initialArea, onClose });

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4" data-testid="relocation-guide-modal">
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={onClose}></div>
      <div className="relative bg-sand-50 rounded-3xl shadow-2xl max-w-lg w-full overflow-hidden animate-fadeInUp">
        <RelocationModalHeader area={form.area} copy={getRelocationCopy(form.area)} onClose={onClose} />
        <RelocationFeatureStrip area={form.area} />
        <div className="p-6">
          {submitted
            ? <RelocationSuccess />
            : <RelocationGuideForm form={form} update={update} onSubmit={handleSubmit} submitting={submitting} onPrivacyClick={() => { onClose(); openPrivacyPolicy(); }} />}
        </div>
      </div>
    </div>
  );
};
